import PropTypes from "prop-types";
import { Divider } from "antd";
import React from "react";
import { connect } from "react-redux";
import closeSmallIcon from "../../../../../../assets/icons/close-small.svg";
import closeIcon from "../../../../../../assets/icons/close.svg";
import AlertBox from "../../../../../../CommonComponents/AlertBox";
import BreadcrumbComponent from "../../../../../../CommonComponents/Breadcrumb/Breadcrumb";
import {
  DataHeading,
  DataValue,
  DisplayFlex,
  PagesHeading,
  Spinner
} from "../../../../../../CommonComponents/commonStyles";
import Contents, {
  ContentMessage,
  ContentProvider,
  Types
} from "../../../../../../CommonComponents/ContentMessages";
import Preloader from "../../../../../../CommonComponents/Preloader/Preloader";
import { flushZipCode } from "../../../../../../CommonComponents/Zipcode/actions";
import history from "../../../../../../history/history";
import {
  getpwUrl,
  initiateTracking,
  recordError
} from "../../../../../../utils/commonUtil";
import { getPrimaryAccount, isGeminiUser } from "../../../../../../utils/sessionUtil";
import {
  doesOthersExist,
  resetLegacy,
  resetLegacyFromApi,
  legacyValuesFromApi,
  updateSuccession,
  showEspSubmitLoader
} from "../../../../actions";
import Constants from "../../../../constants";
import { DividerWrap } from "../../../Step1Setup/Components/RelatedContributor/styles";
import {
  DisplayFlexSpaceMobile,
  GhostButton,
  GhostButtonReset,
  PrimaryButtonComponentNext
} from "../../../Step1Setup/styles";
import { BestowHeading, EndowHeading, SuccessionSubhead } from "../../styles";
import LegacyAccordions from "../LegacyAccordions/LegacyAccordions";
import {
  CloseImage,
  RemainingBanner,
  RemainingBannerDisplay,
  RemainingBannerExceed,
  RemainingBannerWrap
} from "./styles";
import { GeneralButton } from "../../../../../../CommonComponents/Commons/commonComponents";
import { filterTitleData, filterSuffixData, filterRelationData, filterCountryData, filterStateData } from '../../../Data/DropDownData';

class LegacyOptions extends React.Component {
  pageTitle = "Edit Legacy Options";

  annualGrantTitle = "Grant annually";

  legacyContents = [
    {
      id: "1",
      heading: "Add up to two successor advisors",
      content:
        "Please assign a percentage of the remaining account assets to your successor advisor(s). This percentage will be assigned to one successor advisor or split between two successor advisors, if you name a second successor advisor.",
      contentKey: Constants.APPOINT_INDIVIDUAL
    },
    {
      id: "2",
      heading: "Create accounts",
      content: "Create new charitable giving account(s) for named successor advisor(s).",
      contentKey: Constants.CREATE_ACCOUNT
    },
    {
      id: "3",
      heading: "Philanthropic Impact Fund",
      content:
        "Transfer the account's remaining assets to Vanguard Charitable's Philanthropic Impact Fund. This mission-driven fund supports charities that encourage charitable giving and philanthropy.",
      contentKey: Constants.PHILAN_FUND
    },
    {
      id: "4",
      heading: "Give to charity",
      content: "Recommend grants to one or many charities.",
      contentKey: Constants.MULTI_CHARITY
    },
    {
      id: "5",
      heading: "Grant annually",
      content: `<p> To complete the Endowed Grant Plan, <a class="teal-underline" href="/sites/default/files/2019-05/EndowedGrantForm.pdf" target="_blank">download and complete this form</a> and return it to Vanguard Charitable. An email will be sent to the account advisors with a copy of the form and information on returning by fax, mail, or email. See our <a class="teal-underline" href="${getpwUrl()}/company-policies/policies-and-guidelines" target="_blank">Policies & Guidelines</a> for more information.</p>`,
      contentKey: Constants.ANNUAL_GRANT
    },
    {
      id: "6",
      heading: "Others",
      content: "",
      contentKey: Constants.OTHERS
    }
  ];

  constructor(props) {
    super(props);
    this.state = {
      show: false,
      type: "",
      reset: false,
      close: false,
      legacyValues: {},
      othersPercentage: ""      
    };

    this.geminiUser = isGeminiUser();

    this.resetPopupContent = {
      heading: "Clear Information",
      line1: "<p>Clear all will delete all entered information on the page.</p><p>Do you want to continue ?</p>",
      continue: "continue",
      cancel: "No, take me back"
    };

    this.exitPopupContent = {
      heading: "Cancel",
      line1:
        "<p>Cancelling will remove all updates. You will have to start the process again</p><p>Do you want to continue ?</p>",
      continue: "continue",
      cancel: "No, take me back"
    };
  }
  viewEndowedGrantPlanPdf = (elemText = "") => {
    initiateTracking("download", this.getTitle(), this.getGrantAnnualTitle(), elemText);
  };
  componentWillMount() {
    let othersExist = false;
    this.props.legacyOptions &&
      this.props.legacyOptions.forEach(item => {
        if (item.optionId === 6 && item.selected) {
          othersExist = true;
        }
      });
    this.props.legacyValuesFromApi(this.props.legacyOptions);
    this.props.doesOthersExist(othersExist);
  }

  componentWillReceiveProps(nextprops) {   
    this.setState({
      close: false,
      legacyValues: nextprops.legacyValues
    });
    this.getOthersPercentage();
  }

  onClose = () => {
    this.setState({
      close: true
    });
  };

  handleReset = () => {
    this.props.flushZipCode();
    this.setState({
      show: !this.state.show
    });
    window.scrollTo(0, 0);
    this.props.resetLegacyValues();
    this.props.resetLegacy({
      resetLegacy: true
    });
  };

  getFilterStatus = (details, isSucc) => {
    let addrValid = true;
    let detailsValid = true;   
    
    if(!details.successionDetailId || (details.successionDetailId && details.successionDetailId.includes(getPrimaryAccount().userId))) {

      addrValid = !!details.address.line1 && !!details.address.city && !!details.address.zip && !!details.address.country;

      addrValid = details.address.country === "0" ? addrValid && !!details.address.state: addrValid;

      if(isSucc) {
        detailsValid = !!details.firstName && !!details.lastName && details.dobStr !== 'Invalid date' && (!!details.relationshipType || !!details.salesforceRelationshipTypeId);
      } else {
        detailsValid = !!details.name && !!details.charityAllocPercent && !!details.grantRecognition && !!details.grantPurpose;
      }

    }

    return addrValid && detailsValid;
  }

  getPostData = reducerData => {
    const { relationshipDropDownData } = this.props;
    const { suffix: suffixDropDown, title: titleDropDown, states: stateDropDown, countries: countryDropDown } = this.props.dropdownValues;
    let requestData = {
      "accountId": getPrimaryAccount().userId,
      "planModels": []
    }
    if (
      reducerData &&
      reducerData.appointInd &&
      reducerData.appointInd.successorAdvisor &&
      reducerData.appointInd.successorAdvisor.length
    ) {
      reducerData.appointInd.successorAdvisor.forEach(data => {
        if (
          data.address &&
          data.address.country &&
          data.address.country === "0"
        ) {
          this.props.dropdownValues &&
            this.props.dropdownValues.states &&
            this.props.dropdownValues.states.find(item => {
              if (
                item.value === data.address.state ||
                item.desc === data.address.state
              ) {
                data.address.state = item.value;
              }
            });
        }
      });
    }
    if (
      reducerData &&
      reducerData.multiCharity &&
      reducerData.multiCharity.successionPlanGranteeOrg &&
      reducerData.multiCharity.successionPlanGranteeOrg.length
    ) {
      reducerData.multiCharity.successionPlanGranteeOrg.forEach(data => {
        if (
          data.address &&
          data.address.country &&
          data.address.country === "0"
        ) {
          this.props.dropdownValues &&
            this.props.dropdownValues.states &&
            this.props.dropdownValues.states.find(item => {
              if (
                item.value === data.address.state ||
                item.desc === data.address.state
              ) {
                data.address.state = item.value;
              }
            });
        }
      });
    }    
    for (const option of Object.keys(reducerData)) {
      let planModel = reducerData[option];
      delete planModel['hasChange'];
      delete planModel['notes'];      
      planModel.assignedPercentage = planModel.assignedPercentage ? planModel.assignedPercentage: 0;
      planModel.selected = planModel.assignedPercentage > 0 ? true: false;
      if((planModel.optionId === 1 || planModel.optionId === 2) && planModel.successorAdvisor) {
        planModel.successorAdvisor = planModel.successorAdvisor.filter((succ) => {
          return this.getFilterStatus(succ, true)
        }).map((adv) => {          
          if(adv.hasOwnProperty('key')) {
            delete adv['key'];
          }
          adv.salesforceRelationshipTypeId = adv.relationshipType ? adv.relationshipType: (adv.salesforceRelationshipTypeId ? adv.salesforceRelationshipTypeId: null);
          adv.relationship = '';     
          const relation = filterRelationData(adv.salesforceRelationshipTypeId, relationshipDropDownData);
          const title = adv.title ? filterTitleData(adv.title, titleDropDown): null;
          const suffix = adv.suffix ? filterSuffixData(adv.suffix, suffixDropDown): null;
          const country = adv.address.country ? filterCountryData(adv.address.country, countryDropDown): null;
          const state = adv.address.state ? filterStateData(adv.address.state, stateDropDown): null;
          if(adv.hasOwnProperty('relationshipType')) {
            delete adv['relationshipType'];
          }
          if(relation && relation.length) {
            adv.relationship = relation[0].desc;
          }
          if(title && title.length) {
            adv.title = title[0].desc;
          }
          if(suffix && suffix.length) {
            adv.suffix = suffix[0].desc;
          }
          if(country && country.length) {
            adv.address.country = country[0].desc;
          }
          if(state && state.length) {
            adv.address.state = state[0].desc;
          }

          adv.dob = new Date(adv.dobStr).getTime();
          return adv;
        });
      }

      if(planModel.optionId === 4 && planModel.successionPlanGranteeOrg) {
        planModel.successionPlanGranteeOrg = planModel.successionPlanGranteeOrg.filter((chrty) => {
          return this.getFilterStatus(chrty)
        }).map((cha) => {
          if(cha.hasOwnProperty('key')) {
            delete cha['key'];
          }
          if(cha.hasOwnProperty('dob')) {
            delete cha['dob'];
          }
          if(cha.hasOwnProperty('firstName')) {
            delete cha['firstName'];
          }
          if(cha.hasOwnProperty('lastName')) {
            delete cha['lastName'];
          }
          if(cha.hasOwnProperty('middleName')) {
            delete cha['middleName'];
          }
          if(cha.hasOwnProperty('relationshipType')) {
            delete cha['relationshipType'];
          }
          if(cha.hasOwnProperty('suffix')) {
            delete cha['suffix'];
          }
          if(cha.hasOwnProperty('title')) {
            delete cha['title'];
          }

          if(cha.grantPurpose === 'AOMN' || cha.grantPurpose === 'Area of most need') {
            cha.grantPurpose = 'Area of most need';
            cha.otherGrantPurposeText = '';
          } else {
            cha.grantPurpose = 'Other';
          }

          const country = cha.address.country ? filterCountryData(cha.address.country, countryDropDown): null;
          const state =  cha.address.state ? filterStateData(cha.address.state, stateDropDown): null;
          if(country && country.length) {
            cha.address.country = country[0].desc;
          }
          if(state && state.length) {
            cha.address.state = state[0].desc;
          }
          return cha;
        })
      }

      requestData.planModels.push(planModel); 
    }
    return requestData;
  };

  handleUpdate = () => {
    try {      
      const data = this.getPostData(this.state.legacyValues);
      this.props.showEspSubmitLoader();      
      initiateTracking("update2", this.getTitle(), "", "Update");
      const metaData = {
        method: "POST",
        url: `/DP/SuccessionPlan/Edit`,
        page: "editSuccession",
        data,
        isBhoomiUrl:true
      };
      this.props.updateSuccession(metaData);
      window.scrollTo(0, 0);
    } catch (error) {
      recordError(error);
    }
  };

  checkInnerObject = (details, isAdvisor=true) => {
    let disableUpdate = false;
    if(isAdvisor) {
      if(details && details.length > 0) {        
        details.forEach((adv) => {
          if(adv.selected === true && 
            ( !adv.firstName || 
            !adv.lastName ||
            !adv.salesforceRelationshipTypeId ||
            !adv.dobStr ||
            !adv.address.city ||
            !adv.address.country || 
            !adv.address.line1 ||
            (adv.address.country && adv.address.country.toString() === "0" && !adv.address.state) ||
            !adv.address.zip)) {
              disableUpdate = true;
            }
        })
      }
      else {
        disableUpdate = true;
      }
    } else {
      if(details && details.length > 0) {
        details.forEach((adv) => {
          if(adv.selected === true && 
            (!adv.name || 
            !adv.grantPurpose ||
            !adv.grantRecognition ||
            (adv.grantPurpose === "OTHER" && !adv.otherGrantPurposeText) ||
            !adv.charityAllocPercent ||            
            !adv.address.city ||
            !adv.address.country || 
            !adv.address.line1 ||
            (adv.address.country && adv.address.country.toString() === "0" && !adv.address.state) ||
            !adv.address.zip)) {
              disableUpdate = true;
            }
        })
      }
      else {
        disableUpdate = true;
      }
    }
    return disableUpdate;
  }

  disableUpdateButton = () => {   
    const { legacyValues } = this.state;
    const { appointInd, createAcc, multiCharity } = legacyValues;
    let disableBtn1 = false, disableBtn2 = false, disableBtn3 = false;
    
    if(appointInd && appointInd.assignedPercentage > 0) {
      disableBtn1 = this.checkInnerObject(appointInd.successorAdvisor);      
    }

    if(createAcc && createAcc.assignedPercentage > 0) {
      disableBtn2 = this.checkInnerObject(createAcc.successorAdvisor);
    }

    if(multiCharity && multiCharity.assignedPercentage > 0) {
      disableBtn3 = this.checkInnerObject(multiCharity.successionPlanGranteeOrg, false);
    }

    return disableBtn1 || disableBtn2 || disableBtn3;
  }

  renderUpdateButton = () => {
    let updateButtonCondition = this.props.errorVariable;    
    let totalPercentage = this.getTotalPercentage();    
    if (this.props.hasChange === true) {
      if (totalPercentage < 100 || totalPercentage > 100 || this.disableUpdateButton()) {
        return (
          <PrimaryButtonComponentNext disabled id="btninvalidPercentage">
            UPDATE
          </PrimaryButtonComponentNext>
        );
      } else {
        if (updateButtonCondition) {
          return (
            <PrimaryButtonComponentNext
              onClick={this.handleUpdate}
              disabled={this.geminiUser || updateButtonCondition ? true : false}
              id="btnCheckUpdate"
              inverted={false}
            >
              UPDATE
            </PrimaryButtonComponentNext>
          );
        } else {
          return (
            this.props.apiIndicator ? 
                (<GeneralButton
                  id="btnSubmitLoader"
                  type="functional"
                  text={<Spinner />}
                  width="150px"
                  mobWidth = "100%"                
                />)
              : (
            <GeneralButton
              type="functional"
              text="UPDATE"
              id="btnUpdate"
              onClick={this.handleUpdate}
              inverted={false}
              styling="myAccount-secondary-functional-update-button"
              disabled={this.geminiUser ? true : false}
            />
          ));
        }
      }
    } else {
      return (
        <GeneralButton
          type="functional"
          text="UPDATE"
          id="btnUpdateDisabled"
          inverted={false}
          disabled
          styling="myAccount-secondary-functional-update-button"
        />
      );
    }
  };

  getOthersPercentage = () => {
    const othersOption = this.state.legacyValues[Constants.OTHERS];
    if (othersOption) {
      this.setState({
        othersPercentage: othersOption.assignedPercentage
          ? othersOption.assignedPercentage
          : 0
      });
    }
  };
  getOthersPercentageMessage = display => {
    if (this.props.othersExist) {
      return (
        <DisplayFlex displayType={display} className="my-30">
          <DataValue className="mr2">Note:</DataValue>
          <DataHeading>
            {this.state.othersPercentage}% of the total has been allocated to
            ‘Other’ legacy option.
          </DataHeading>
        </DisplayFlex>
      );
    }
  };

  getTotalPercentage = () => {
    let totalPercentage = 0;
    const data = this.state.legacyValues;
    for (const option of Object.keys(data)) {
      if (data[option].assignedPercentage && data[option].selected) {
        totalPercentage += parseInt(data[option].assignedPercentage);
      } else {
        totalPercentage += 0;
      }
    }
    return totalPercentage;
  };

  getRemainingPercentage = display => {
    let w = window.innerWidth;
    let totalPercentage = this.getTotalPercentage();
    let remainingPercentage = 100 - totalPercentage;
    if (remainingPercentage > 0 && remainingPercentage !== 100) {
      return (
        <RemainingBannerWrap
          data-test="remainingBannerWrap"
          displayType={display}
        >
          <RemainingBanner>
            You have {remainingPercentage}% more to allocate.
          </RemainingBanner>
          {w > 360 ? (
            <CloseImage src={closeIcon} onClick={this.onClose} />
          ) : (
            <CloseImage src={closeSmallIcon} onClick={this.onClose} />
          )}
        </RemainingBannerWrap>
      );
    }
    if (totalPercentage > 100) {
      return (
        <RemainingBannerExceed
          data-test="remainingBannerExceed"
          displayType={display}
        >
          <RemainingBannerDisplay>
            The Succession Plan allocation total percentage must equal 100%.
            Please check.
            {w > 360 ? (
              <CloseImage src={closeIcon} onClick={this.onClose} />
            ) : (
              <CloseImage src={closeSmallIcon} onClick={this.onClose} />
            )}
          </RemainingBannerDisplay>
        </RemainingBannerExceed>
      );
    }
  };

  closeModal = () => {
    this.setState({
      show: false
    });
  };

  setTitle = (title = "") => {
    if (title) {
      this.pageTitle = title;
    }
  };

  getTitle = () => {
    return this.pageTitle;
  };

  setGrantAnnualTitle = title => {
    if (title) {
      this.annualGrantTitle = title;
    }
  };

  getGrantAnnualTitle = () => {
    return this.annualGrantTitle;
  };

  handleExitClick = () => {
    initiateTracking("cancel2", this.getTitle(), "", "Cancel");
    this.setState({
      show: !this.state.show
    });
    history.push("/my-account");
    window.scrollTo(0, 0);
  };

  breadcrumbRoutes = () => {
    return [
      {
        routeName: "Home",
        path: "/"
      },
      {
        routeName: "My Account",
        path: "/my-account"
      },
      {
        routeName: "Edit Legacy Options",
        path: ""
      }
    ];
  };
  render() {
    let display = "none";
    if (this.props.showRemainingPercentage) {
      if (this.state.close === false) {
        display = "flex";
      } else {
        display = "none";
      }
    } else {
      display = "none";
    }

    // Fix me - remove this preloader from here
    if (
      this.props.dropdownAll === true ||
      this.props.relationshipDropDown === true
    )
      return <Preloader data-test="contentLoader" />;
    return (
      <ContentProvider
        data-test="collapseWrap"
        types={[Types.SUB_HEADING_LEGACY_OPTIONS]}
        pages={["Legacy options"]}
      >
        <div className="legacy-form">
          <BreadcrumbComponent breadcrumbRoutes={this.breadcrumbRoutes()} />
          <ContentProvider
            data-test="contentProvider"
            types={[Types.PAGE_TITLE_DESCRIPTION]}
            pages={["Edit Legacy Options"]}
          >
            <PagesHeading data-test="contentHeading">
              <ContentMessage
                type={[Types.PAGE_TITLE_DESCRIPTION]}
                page="Edit Legacy Options"
                property="field_page_title"
                defaultMessage={Constants.PAGE_TITLE}
                setTitle={this.setTitle}
              />
            </PagesHeading>
            <SuccessionSubhead data-test="contentSubHeading">
              <ContentMessage
                type={[Types.PAGE_TITLE_DESCRIPTION]}
                html={true}
                page="Edit Legacy Options"
                property="description__value"
                defaultMessage={
                  "<p>This section allows you to recommend one or more plans that will be enacted when all account advisors are unable or unwilling to manage the account. Choose the options that best fit your giving goals and assign percentages accordingly. As percentages are applied to each succession option, the total percentage will be reflected to the left of each offering, and the total of all options must equal 100%. Be sure to click Save to Continue at the end of each section and then click Next to move to the next step.</p>"
                }
              />
            </SuccessionSubhead>
          </ContentProvider>
          {this.props.showRemainingPercentage
            ? this.getRemainingPercentage(display)
            : null}

          <BestowHeading data-test="contentBestowHead" marginBottom="16px">
            Bestow to others
          </BestowHeading>
          <Contents.Consumer data-test="contentConsumer">
            {content => {
              let legacyOptions =
                content &&
                content[Types.SUB_HEADING_LEGACY_OPTIONS] &&
                content[Types.SUB_HEADING_LEGACY_OPTIONS]["Legacy options"]
                  ? content[Types.SUB_HEADING_LEGACY_OPTIONS]["Legacy options"]
                  : null;
              if (legacyOptions && !legacyOptions.error) {
                this.setGrantAnnualTitle(legacyOptions["field_type_5_title"]);
              }

              return (
                <ContentProvider
                  data-test="provider"
                  types={[Types.PAGE_ALERTS]}
                  pages={["Edit legacy options"]}
                >
                  <AlertBox
                    data-test="resetInfo"
                    field_page="Edit legacy options"
                    name="Reset Info"
                    show={this.state.show && this.state.type === "reset"}
                    primaryBtnEvent={this.handleReset.bind(this)}
                    secondaryBtnEvent={this.closeModal.bind(this)}
                    defaultContent={this.resetPopupContent}
                  />

                  <AlertBox
                    data-test="exitForm"
                    field_page="Edit legacy options"
                    name="Exit Form"
                    show={this.state.show && this.state.type === "exit"}
                    primaryBtnEvent={this.handleExitClick.bind(this)}
                    secondaryBtnEvent={this.closeModal.bind(this)}
                    defaultContent={this.exitPopupContent}
                  />
                  {this.legacyContents.map((item, index) => {
                    return (
                      <>
                        {item.id === "3" && (
                          <EndowHeading marginBottom="16px">
                            Endow to charity
                          </EndowHeading>
                        )}
                        {item.id === "6" ? (
                          this.props.legacyValues.others &&
                          this.props.legacyValues.others.selected &&
                          this.props.legacyValues.others.assignedPercentage > 0 && (
                            <LegacyAccordions
                              data-test="legacyOptionLegacyAcc7"
                              key={index}
                              id={`${item.heading}${item.id}`}
                              viewEndowedGrantPlanPdf={text =>
                                this.viewEndowedGrantPlanPdf(text)
                              }
                              getTitle={this.getTitle.bind(this)}
                              legacyOptions={legacyOptions}
                              subTitle={item.heading}
                              subDesc={
                                this.props.legacyValues.others.notes || ""
                              }
                              contentKey={item.contentKey}
                            />
                          )
                        ) : (
                          <LegacyAccordions
                          data-test="legacyOptionLegacyAccordion"
                          key={index}
                            id={item.id}
                            viewEndowedGrantPlanPdf={text =>
                              this.viewEndowedGrantPlanPdf(text)
                            }
                            getTitle={this.getTitle.bind(this)}
                            legacyOptions={legacyOptions}                            
                            subTitle={item.heading}
                            subDesc={item.content}
                            contentKey={item.contentKey}
                          />
                        )}
                      </>
                    );
                  })}
                </ContentProvider>
              );
            }}
          </Contents.Consumer>
          <DividerWrap>
            <Divider data-test="contentDivider" />
          </DividerWrap>
          <DisplayFlexSpaceMobile>
            <DisplayFlex className="justify-between">
              <GeneralButton
                type="functional"
                text="CANCEL"
                id="btnLegacyOptionCancel"
                onClick={() => {
                  this.setState({
                    show: !this.state.show,
                    type: "exit"
                  });
                }}
                inverted
                mobMargin="0 15px 15px 0"
                styling="myAccount-secondary-functional-button"
              />

              <GeneralButton
                data-test="legacyOptionClearButton"
                type="functional"
                text="CLEAR"
                mobMargin="0 0 10px 0"
                id="btnLegacyOptionClear"
                onClick={() =>
                  this.setState({
                    show: !this.state.show,
                    type: "reset",
                    reset: true
                  })
                }
                inverted
                styling="myAccount-secondary-functional-button"
                disabled={this.geminiUser ? true : false}
              />
            </DisplayFlex>
            {this.renderUpdateButton()}
          </DisplayFlexSpaceMobile>
        </div>
      </ContentProvider>
    );
  }
}

export const mapStateToProps = state => ({
  errorVariable: state.getIn(["myAccount", "errorVariable"]),
  legacyValues: state.getIn(["myAccount", "legacyValues"]),
  apiIndicator: state.getIn(["myAccount", "apiIndicator"]),
  hasChange: state.getIn(["myAccount", "hasChange"]),
  showRemainingPercentage: state.getIn([
    "myAccount",
    "showRemainingPercentage"
  ]),
  othersExist: state.getIn(["myAccount", "othersExist"]),
  dropdownAll: state.getIn(["myAccount", "dropdownValues", "isLoading"]),
  relationshipDropDown: state.getIn([
    "myAccount",
    "relationshipValues",
    "isLoading"
  ]),
  dropdownValues: state.getIn(["myAccount", "dropdownValues", "data"]),
  relationshipDropDownData: state.getIn([
    "myAccount",
    "relationshipValues",
    "data"
  ]),
});

export const mapDispatchToProps = dispatch => ({
  legacyValuesFromApi: val => dispatch(legacyValuesFromApi(val)),
  resetLegacyValues: val => dispatch(resetLegacyFromApi(val)),
  resetLegacy: val => dispatch(resetLegacy(val)),
  updateSuccession: val => dispatch(updateSuccession(val)),
  doesOthersExist: val => dispatch(doesOthersExist(val)),
  flushZipCode: () => dispatch(flushZipCode()),
  showEspSubmitLoader: () => dispatch(showEspSubmitLoader())
});

LegacyOptions.propTypes = {
  doesOthersExist: PropTypes.func,
  dropdownAll: PropTypes.bool,
  dropdownValues: PropTypes.shape({
    states: PropTypes.array
  }),
  errorVariable: PropTypes.any,
  flushZipCode: PropTypes.func,
  hasChange: PropTypes.bool,
  apiIndicator: PropTypes.bool,
  legacyOptions: PropTypes.array,
  legacyValues: PropTypes.shape({
    others: PropTypes.shape({
      assignedPercentage: PropTypes.number,
      notes: PropTypes.string
    })
  }),
  legacyValuesFromApi: PropTypes.func,
  othersExist: PropTypes.any,
  relationshipDropDown: PropTypes.bool,
  resetLegacy: PropTypes.func,
  resetLegacyValues: PropTypes.func,
  showRemainingPercentage: PropTypes.any,
  updateSuccession: PropTypes.func,
  relationshipDropDownData: PropTypes.any
};

export default connect(mapStateToProps, mapDispatchToProps)(LegacyOptions);
